import { useTranslation } from "react-i18next";
import { TbArrowBack } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

const BackButton = ({ to, onBack }: { to?: string; onBack?: () => void }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    // Always call onBack if provided
    onBack?.();

    // Then handle navigation
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button startIcon={<TbArrowBack />} onClick={handleClick}>
      {t("general.back")!}
    </Button>
  );
};

export default BackButton;
